export const CS: Record<string, string> = {
  Home: "Domů",
  "Resource Selected": "Vybraný zdroj",
  "Resources List": "Seznam zdrojů",
  List: "Seznam",
  Resources: "Zdroje",
  "Find Colleague": "Najít kolegu",
  Settings: "Nastavení",
  "Floor Plan": "Plán podlaží",
  Locations: "Lokace",
  Categories: "Kategorie",
  "Search resource name...": "Vyhledat název zdroje...",
  Calendar: "Kalendář",
  "View Details": "Zobrazit detaily",
  "Add to My Favorites": "Přidat do oblíbených",
  Remove: "Odebrat",
  "Resource calendar": "Kalendář zdroje",
  Today: "Dnes",
  "Previous month": "Předchozí měsíc",
  "Next month": "Příští měsíc",
  "Previous year": "Předchozí rok",
  "Next year": "Příští rok",
  Close: "Zavřít",
  "Field is required.": "Pole je povinné.",
  "Invalid date format.": "Neplatný formát data.",
  S: "Ne",
  M: "Po",
  T: "Út",
  W: "St",
  F: "Pá",
  January: "ledna",
  February: "února",
  March: "března",
  April: "dubna",
  May: "května",
  June: "června",
  July: "července",
  August: "srpna",
  September: "září",
  October: "října",
  November: "listopadu",
  December: "prosince",
  Jan: "led",
  Feb: "úno",
  Mar: "bře",
  Apr: "dub",
  Jun: "čer",
  Jul: "čec",
  Aug: "srp",
  Sep: "zář",
  Oct: "říj",
  Nov: "lis",
  Dec: "pro",
  st: ".",
  nd: ".",
  rd: ".",
  th: ".",
  Sunday: "neděle",
  Monday: "pondělí",
  Tuesday: "úterý",
  Wednesday: "středa",
  Thursday: "čtvrtek",
  Friday: "pátek",
  Saturday: "sobota",
  Sun: "Ne",
  Mon: "Po",
  Tue: "Út",
  Wed: "St",
  Thu: "Čt",
  Fri: "Pá",
  Sat: "So",
  Su: "Ne",
  Mo: "Po",
  Tu: "Út",
  We: "St",
  Th: "Čt",
  Fr: "Pá",
  Sa: "So",
  PM: "PM",
  AM: "AM",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "Nemůžete rezervovat tento zdroj, protože váš požadavek na schůzku je v rozporu s rezervačními pravidly zdroje.",
  "You need permissions to interact with this resource.":
    "Potřebujete oprávnění k interakci s tímto zdrojem.",
  Reason: "Důvod",
  "The resource cannot be booked {{day}} days in advanced.":
    "Zdroj nelze rezervovat {{day}} dnů předem.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "Koncové datum opakované schůzky nemůže být více než {{day}} dnů od dneška.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "Doba trvání schůzky nesmí být delší než {{time}} minut.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "Doba trvání schůzky nesmí být kratší než {{time}} minut.",
  "Booking policy": "Rezervační politika",
  Available: "Dostupný",
  Selected: "Vybraný",
  Booked: "Rezervováno",
  Closed: "Zavřeno",
  "Filter Options": "Možnosti filtru",
  "{{resource}} is deleted": "{{resource}} byl smazán.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "Tento zdroj lze rezervovat, ale všechny výskyty s konflikty zdroje nebudou rezervovány.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "Tento zdroj lze rezervovat dopředu maximálně na {{day}} dní, všechny výskyty přesahující tuto hranici nebudou rezervovány",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "Tento zdroj lze rezervovat, ale doba trvání schůzky musí být alespoň {{time}} minut.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "Tento zdroj lze rezervovat, ale doba trvání schůzky nesmí přesáhnout {{time}} minut.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "Rezervace tohoto zdroje vyžaduje schválení delegátem zdroje. Váš požadavek bude předán k posouzení.",
  "Resource Name": "Název zdroje",
  Description: "Popis",
  "Resource Mail": "E-mail zdroje",
  Location: "Lokace",
  Capacity: "Kapacita",
  Language: "Jazyk",
  "Select an language": "Vyberte jazyk",
  "Date/Time Format": "Formát data/času",
  "First day of the week": "První den v týdnu",
  "Please select a first day": "Prosím vyberte první den",
  "Please select a time format": "Prosím vyberte formát času",
  "Date Format": "Formát data",
  "Please select a date format": "Prosím vyberte formát data",
  "Date Separator": "Oddělovač dat",
  "Please select a date separator": "Prosím vyberte oddělovač dat",
  Apply: "Použít",
  "Default Location": "Výchozí lokace",
  Clear: "Vymazat",
  Help: "Nápověda",
  "Unavailable": "Nedostupné",
  "No data available": "Žádná dostupná data",
  "More": "Více",
  "Available Floor Plans": "Dostupné plány podlaží",
  "Default Categories": "Výchozí kategorie",
  "List more Resources": "Zobrazit více zdrojů",
  Attendees: "Účastníci",
  "Click on Further information to visit our support site":
    "Klikněte na Další informace pro návštěvu našich podpůrných stránek",
  "New Order": "Nová objednávka",
  "Save default categories successfully": "Kategorie byly úspěšně uloženy",
      "Save config date/time successfully": "Datum/čas konfigurace byl úspěšně uložen",
      "Save language successfully": "Jazyk byl úspěšně uložen",
      "Save default location successfully": "Výchozí umístění bylo úspěšně uloženo",
      "And": "A",
  "Or": "Nebo",
  "Available occurrences of the series": "Dostupné výskyty série",
  "Conflicting Occurrences": "Konfliktní výskyty",
  "Availability": "Dostupnost",
  "Time Format": "Časový formát",
  "You do not have permission to book this resource.": "Nemáte oprávnění k rezervaci tohoto zdroje.",
"This resource does not allow booking of recurring meetings.": "Tento zdroj nepovoluje rezervaci opakujících se schůzek.",
"You cannot book this resource.": "Nemůžete rezervovat tento zdroj."
};
